import React, { useState, useEffect } from "react";
import "../CSS/Style.css";
import axios from "axios";
import Header from './Header'
import Pagination from "./Pagination";

const generateRandomPassword = () => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@#$!";
    let password = "";
    for (let i = 0; i < 8; i++) {
        password += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return password;
};

const Dealer = () => {
    const [email, setEmail] = useState("");
    const [token, setToken] = useState("");
    const [dealer, setDealer] = useState({ name: "", mobile: "", email: "", password: "" });
    const [message, setMessage] = useState("");
    const [dealers, setDealers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [dealermessage, setDealermessage] = useState('');

    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10); 



    useEffect(() => {
        let storedToken = sessionStorage.getItem("token");
        let storedEmail = sessionStorage.getItem("email");

        if (!storedToken || !storedEmail) {
            window.location.href = "/signin";
        } else {
            setToken(storedToken);
            setEmail(storedEmail);

            const config = { headers: { Authorization: `Bearer ${storedToken}` } };
            axios.get("https://api.mahirefrigeration.com/api/validateToken", config)
                .then((res) => {
                    if (res.data === "User validation failed") {
                        sessionStorage.clear();
                        window.location.href = "/signin";
                    }
                });

            // Generate and set a random password on page load
            const randomPassword = generateRandomPassword();
            setDealer((prevDealer) => ({ ...prevDealer, password: randomPassword }));
        }
        fetchDealers();
    }, []);

    const fetchDealers = async () => {
      setLoading(true);
      try {
        const token = sessionStorage.getItem("token");
        const config = { headers: { Authorization: `Bearer ${token}` } };
        const response = await axios.get("https://api.mahirefrigeration.com/api/get_all_dealers", config);
    
        if (response.data.success) {
          setDealers(response.data.dealers.reverse());
        } else {
          setDealermessage(response.data.message);
        }
      } catch (error) {
        setDealermessage("Failed to fetch dealers. Try again.");
      } finally {
        setLoading(false);
      }
    };

    const handleChange = (e) => {
        setDealer({ ...dealer, [e.target.name]: e.target.value });
    };

    const createDealer = async (e) => {
        e.preventDefault();

        if (!dealer.name || !dealer.mobile || !dealer.email || !dealer.password) {
            setMessage("All fields are required.");
            return;
        }

        const config = { headers: { Authorization: `Bearer ${token}` } };

        try {
            const res = await axios.post("https://api.mahirefrigeration.com/api/create_dealer", dealer, config);
            setMessage(res.data.message);

            if (res.data.success) {
                const newPassword = generateRandomPassword();
                setDealer({ name: "", mobile: "", email: "", password: newPassword });
                fetchDealers();
            }
        } catch (err) {
            setMessage("Error creating dealer. Try again.");
        }
    };

    const indexOfLastDealer = currentPage * rowsPerPage;
    const indexOfFirstDealer = indexOfLastDealer - rowsPerPage;
    const currentDealers = dealers.slice(indexOfFirstDealer, indexOfLastDealer);

    return (
        <>
          <Header/>
          <div className="first_sec_ran">
          <div className="container">
            <div className="row my-4" style={{}}>
                <div className="col-md-6 mt-4">
                <div className="container">
            <form onSubmit={createDealer}>
            <div className='parent' style={{position:"relative",height:"90vh"}}>
            <div className="box" style={{ width:"100%",flex: "2", padding: "20px", background: "#fff", borderRadius: "8px", boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",height:"470px",overflow:"auto"}}>
        <div style={{textAlign:"left",color:"#000"}}>
        <h2 style={{color:"skyblue"}}>Create A Dealer</h2>
        </div>
            <div class="form__group field">
            <label for="name" class="form__label">Name</label>
            <input type="text" class="form__field" placeholder="Name" name="name" value={dealer.name} onChange={handleChange} required />
            </div>
            <div class="form__group field">
            <label for="mobile" class="form__label">Mobile</label>
            <input type="number" class="form__field" name="mobile" placeholder="Mobile" value={dealer.mobile} onChange={handleChange} required />
            </div>
            <div class="form__group field">
            <label for="email" class="form__label">Email</label>
            <input type="email" class="form__field" name="email" placeholder="Email" value={dealer.email} onChange={handleChange} required />
            </div>
            <div class="form__group field">
            <label for="password" class="form__label">Password</label>
            <input type="text" class="form__field" name="password" placeholder="Generated Password" value={dealer.password} readOnly />
            </div>
          
            <div class="form__group field">
            <button type="submit" class="btn" style={{minWidth:"50%",border:"1px solid skyblue",backgroundcolor:"#000",color:"#000"}}>Create Dealer</button>
            <br/>
            <p>{message && <p className="message">{message}</p>}</p>
            </div>
		</div> 
        </div>
        </form>
          </div>
                </div>
                <div className="col-md-6 mt-4">
                  <div className="container">
                    <div className="parent" style={{ position: "relative", height: "" }}>
                    <div className="box" style={{ width:"100%",flex: "2", padding: "20px", background: "#fff", borderRadius: "8px", boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",height:"470px",overflow:"auto"}}>
                        {/* <div className="box" style={{ padding:"20px",width: "100%", background: "#fff", borderRadius: "8px", boxShadow: "0px 4px 6px rgba(0,0,0,0.1)" }}> */}
                          <h2 style={{ color: "skyblue" }}>All Dealers</h2>
                          {dealermessage && <p>{dealermessage}</p>}
                          {dealers.length > 0 ? (
                            <div className="table-wrapper" style={{ overflowX: "scroll", minWidth: "100%" }}>
                              <table className="table">
                                <thead>
                                  <tr>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Mobile</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {currentDealers.map((dealer, index) => (
                                    <tr key={index}>
                                      <td>{dealer.name}</td>
                                      <td>{dealer.email}</td>
                                      <td>{dealer.mobile}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          ) : (
                            <p>No dealers found</p>
                          )}


                          {/* <div className="pagination">
                            {[...Array(Math.ceil(dealers.length / rowsPerPage)).keys()].map((number) => (
                              <button key={number + 1} onClick={() => setCurrentPage(number + 1)} className={currentPage === number + 1 ? "active" : ""}>
                                {number + 1}
                              </button>
                            ))}
                          </div> */}
                          <Pagination
                          currentPage={currentPage}
                          totalItems={dealers.length}
                          itemsPerPage={20}
                          onPageChange={setCurrentPage}
                          />

                        </div>
                      </div>
                    </div>
                  {/* </div> */}
                </div>

            </div>
            </div>
          </div>
        </>
    );
};

export default Dealer;
